export class CreditCardContactInfo {
  public Id: number = 0;
  public Address1: string = '';
  public Address2: string = '';
  public City: string = '';
  public State: string = '';
  public Zip: string = '';
  public ZipExt: string = '';
  public County: string = '';
  public Country: string = '';
  public Phone: string = '';
  public Ext: string = '';
  public Email: string = '';
  public IsCCAddress: boolean = false;
  public NameOnCard: string = '';
  public FirstName: string = '';
  public LastName: string = '';
  public OrgName: string = '';
}
